export enum StateType {
  TX = 'TX',
}
